import Base from 'app/views/base';

import tmpl from './template';

export default Base.extend({
  compiledTemplate: tmpl,

  context() {
    // Some objects may be missing a Tracker (ex: Shipment that isn't purchased)
    if (this.model) {
      return {
        trackingCode: this.model.get('tracking_code'),
        publicUrl: this.model.get('public_url'),
      };
    }
    return { noTracker: true };
  },
});



// WEBPACK FOOTER //
// ./app/components/list/item/headings/tracking_code/index.js